import React from 'react'
import { useTranslation } from 'react-i18next'
import { PaymentMethodModel } from '@/features/billing/types'
import { DefaultControl, RemoveControl } from './Controls'

interface IProps {
  config?: {
    default: boolean
    remove: boolean
  }
  data: PaymentMethodModel
  defaultControlProps?: any
  removeControlProps?: any
}

const defaultConfig = {
  default: true,
  remove: true,
}

export const Action = ({ data, config, defaultControlProps, removeControlProps }: IProps) => {
  const { t } = useTranslation()

  config = {
    ...defaultConfig,
    ...config,
  }

  return (
    <div className={'flex gap-4 items-center'}>
      {config?.default && !data?.default && <DefaultControl data={data} />}

      {config?.remove && <RemoveControl data={data} {...removeControlProps} />}
    </div>
  )
}
